var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/business/calendar_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 8V12.6667C14 13.4031 13.4031 14 12.6667 14H3.33333C2.59695 14 2 13.4031 2 12.6667V8H14ZM10.6667 2C11.0349 2 11.3333 2.29848 11.3333 2.66667V3.33333H12.6667C13.4031 3.33333 14 3.93029 14 4.66667V6.66667H2V4.66667C2 3.93029 2.59695 3.33333 3.33333 3.33333H4.66667V2.66667C4.66667 2.29848 4.96515 2 5.33333 2C5.70152 2 6 2.29848 6 2.66667V3.33333H10V2.66667C10 2.29848 10.2985 2 10.6667 2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFill);
export default __webpack_public_path__ + "static/media/calendar_fill.13104d537348482284e7ec005c907261.svg";
export { ForwardRef as ReactComponent };